import BreadcrumbListSD from 'components/common/SEO/BreadcrumbListSD'
import CourseDataLayer from 'components/common/SEO/CourseDataLayer'
import CourseSD from 'components/common/SEO/CourseSD'
import ProductSD from 'components/common/SEO/ProductSD'
import FacebookOGMetas from 'components/common/SEO/FacebookOGMetas'
import OrganisationSD from 'components/common/SEO/OrganisationSD'
import TwitterMarups from 'components/common/SEO/TwitterMarups'
import VideoObjectSD from 'components/common/SEO/VideoObjectSD'
import WebPageSD from 'components/common/SEO/WebPageSD'
import WebSiteSD from 'components/common/SEO/WebSiteSD'
import { CourseNeutralPath, CategoryNeutralPath } from 'navigation/Routes'
import { Helmet } from 'react-helmet'
import { useParams } from 'react-router-dom'
import Text from './text.json'

const breadcrumbList = (courseSlug, title, category) => [
  {
    link: window.location.origin,
    name: 'Accueil'
  },
  {
    link: `${window.location.origin}${CategoryNeutralPath}/${category}`,
    name: 'formations'
  },
  {
    link: `${window.location.origin}${CourseNeutralPath}/${courseSlug}`,
    name: title
  }
]

export default ({
  title,
  subtitle,
  category,
  tag,
  duration,
  image,
  slug,
  metaTitle,
  metaDescription
}) => {
  const { videoSlug } = useParams()
  const description = `${subtitle} ${Text.description} ${tag} ${category} ${title} ${category} ${duration}`
  const courseSlug = videoSlug ? `${slug}/${videoSlug}` : `${slug}`
  const link = `${window.location.origin}${CourseNeutralPath}/${slug}`
  const isDataLoaded = title && subtitle && category && tag && duration && image && slug
  if (!isDataLoaded) return null
  return (
    <>
      <Helmet>
        <title>{metaTitle || `${Text.prefixTitle} ${title} ${Text.suffixTitle}`}</title>
        <meta name='description' content={metaDescription || description} />
        <link rel='canonical' href={link} />
      </Helmet>
      <FacebookOGMetas
        link={link}
        title={title}
        description={description}
        image={image}
      />
      <TwitterMarups
        link={link}
        title={title}
        description={description}
        image={image}
      />
      <OrganisationSD />
      <WebSiteSD />
      <WebPageSD
        title={title}
        description={description}
      />
      <CourseSD />
      <ProductSD />
      <VideoObjectSD />
      <BreadcrumbListSD items={breadcrumbList(courseSlug, title, category)} />
      <CourseDataLayer />
    </>
  )
}
